import { useState, useEffect } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import api from "../lib/apiClient";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2, Lock } from "lucide-react";
import { toast, Toaster } from "sonner";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("ingelec_admin_token")) {
      nav("/admin", { replace: true });
    }
  }, [nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ingelec_admin_token", data.token);
      toast.success("Connexion réussie");
      nav("/admin");
    } catch {
      toast.error("Identifiants incorrects");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" data-testid="page-admin-login">
      <Toaster position="top-right" />
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#1B3A6B] text-white mb-4">
            <Lock className="w-6 h-6" />
          </div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Administration INGélec</h1>
          <p className="mt-2 text-sm text-slate-600">Accès réservé à la gestion du catalogue.</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-2xl border border-slate-200 p-7" data-testid="admin-login-form">
          <div className="space-y-4">
            <div>
              <Label htmlFor="ae">Email</Label>
              <Input id="ae" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1.5 h-11" data-testid="admin-login-email" />
            </div>
            <div>
              <Label htmlFor="ap">Mot de passe</Label>
              <Input id="ap" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1.5 h-11" data-testid="admin-login-password" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full mt-6 h-11 bg-[#1B3A6B] hover:bg-[#142c54] rounded-full" data-testid="admin-login-submit">
            {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
            Se connecter
          </Button>
        </form>
      </div>
    </div>
  );
}

export function RequireAdmin({ children }) {
  const token = localStorage.getItem("ingelec_admin_token");
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}
